export default "__VITE_ASSET__BDLTelb4__"